import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@atoms';
import { TextInputWrapper } from './layout';

export const TextInput = ({ id, label, inline, gap, icon, underlined, ...rest }) => (
  <TextInputWrapper inline={inline} gap={gap} underlined={underlined}>
    {label && <label htmlFor={id}>{label}</label>}
    <input id={id} {...rest} />
    {icon && (
      <label htmlFor={id}>
        <Icon name={icon} />
      </label>
    )}
  </TextInputWrapper>
);

TextInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node,
  gap: PropTypes.string,
  icon: PropTypes.string,
};



// WEBPACK FOOTER //
// ./components/molecules/TextInput/TextInput.js